// 9fbef606107a605d69c0edbcd8029e5d

export const getShopByLookStyliticsDataByTag = (state) =>
  state?.shopByLookStylitics?.shopByLookStyliticsData;

export const isShopByLookStyliticsLoading = (state, uniqueKey) =>
  state?.shopByLookStylitics?.loading[uniqueKey];

export const getShopByLookStyliticsError = (state, uniqueKey) =>
  state?.shopByLookStylitics?.errors[uniqueKey] || null;
